import { ChangeEvent } from "react";

import { FormControlLabel, Switch } from "@mui/material";
import {
  Controller,
  ControllerProps,
  FieldPath,
  FieldValues,
  PathValue,
  useFormContext,
} from "react-hook-form";

const SwitchHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  label,
  disabled,
}: Omit<ControllerProps<TFieldValues, TName>, "control" | "render"> & {
  label: string | React.ReactNode;
}) => {
  const { control } = useFormContext<TFieldValues>();
  const parseValue = (value: unknown): boolean => {
    if (typeof value === "string") {
      return value === "true" || value === "1";
    }
    if (typeof value === "number") {
      return value === 1;
    }
    return Boolean(value);
  };
  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field: { ref, onChange, value } }) => (
        <FormControlLabel
          control={
            <Switch
              inputRef={ref}
              checked={parseValue(value)}
              name={name}
              onChange={(_e, checked) =>
                onChange(
                  checked as unknown as
                    | PathValue<TFieldValues, TName>
                    | ChangeEvent<Element>
                )
              }
              disabled={disabled}
            />
          }
          label={label}
        />
      )}
    />
  );
};

export default SwitchHookForm;
